function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useCookie from 'react-use-cookie';
import Cookies from 'js-cookie';
import classNames from 'classnames';
import Button from '../Button';
import Container from '../Layout/Container';
import Checkbox from './Checkbox';
import './style.scss';
var STATUS_DECLINED = '0';
var STATUS_NOT_YET_ANSWERED = '1';
var STATUS_ACCEPTED = '2';
var CookieCompliancePopup = function CookieCompliancePopup(props) {
  var className = props.className,
    children = props.children,
    manualText = props.manualText,
    agreeText = props.agreeText,
    disagreeText = props.disagreeText,
    showDisagree = props.showDisagree,
    onAgree = props.onAgree,
    onDisagree = props.onDisagree,
    cookieLevels = props.cookieLevels,
    cookieOptions = props.cookieOptions,
    cookieDomain = props.cookieDomain,
    defaultValues = props.defaultValues,
    manualHeader = props.manualHeader,
    manualButtonClassname = props.manualButtonClassname;
  // This is an internal state to check whether we should show the options.
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    manualChoiceVisible = _useState2[0],
    setManualChoiceVisible = _useState2[1];
  // This is an internal state to check whether the user has answered in the current session.
  // It is either null (because we don't know if it was already in the cookies) or true
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    answeredInCurrentSession = _useState4[0],
    setAnsweredInCurrentSession = _useState4[1];

  // Cookie stating if the cookie has already been accepted. Uses the following states:
  // null: unknown
  // STATUS DECLINED (0 as cookie value)
  // STATUS NOT YET ANSWERED (1 as cookie value)
  // STATUS ACCEPTED (2 as cookie value)
  var _useCookie = useCookie('cookie-agreed', null),
    _useCookie2 = _slicedToArray(_useCookie, 2),
    didConsent = _useCookie2[0],
    setDidConsent = _useCookie2[1];
  var categories = cookieLevels.map(function (item) {
    return item.value;
  });
  var defaultState = categories.reduce(function (prev, category) {
    // eslint-disable-next-line valid-typeof
    prev[category] = _typeof(defaultValues[category]) !== undefined ? defaultValues[category] : true;
    return prev;
  }, {});

  // Default choices for select, this way we can locally manage the state of the form.
  var _useState5 = useState(defaultState),
    _useState6 = _slicedToArray(_useState5, 2),
    choicesSelected = _useState6[0],
    setChoicesSelected = _useState6[1];
  useEffect(function () {
    // We now know the value of the cookie. If there is no cookie set,
    // immediately set the didConsent state to STATUS_NOT_YET_ANSWERED.
    if (didConsent === null) {
      setDidConsent(STATUS_NOT_YET_ANSWERED, cookieOptions);
    }
  }, [didConsent, cookieOptions, setDidConsent]);
  var isLoading = didConsent === null;
  var isPrompting = didConsent === STATUS_NOT_YET_ANSWERED;
  var isAnswered = didConsent === STATUS_ACCEPTED || didConsent === STATUS_DECLINED;

  // This function expands the notification to show the options.
  var displayConsentChoices = function displayConsentChoices(e) {
    e.preventDefault();
    setManualChoiceVisible(true);
  };

  // This function sets cookie-agreed to STATUS_ACCEPTED,
  // and also sets the accepted categories in CookieAgreedCategories.
  var _onAgree = function _onAgree(choices) {
    var selectedChoices = Object.keys(choices).filter(function (key) {
      return choices[key];
    });
    Object.keys(choices).forEach(function (key) {
      if (choicesSelected[key]) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "cookies-accepted-".concat(key)
        });
      }
    });
    setDidConsent(STATUS_ACCEPTED, cookieOptions);
    setAnsweredInCurrentSession(true);

    // I used js-cookie for this insead of react-use-cookie because the encoding is not what we want
    // for arrays in react-use-cookie. This shouldn't be an issue, as we don't want to keep track of
    // CookieAgreedCategories, as we have that in state already.
    Cookies.set('cookie-agreed-categories', JSON.stringify(selectedChoices), {
      expires: 365,
      domain: cookieDomain
    });

    // Set cookie for current domain, so it does not appear twice.
    var timestamp = Math.round(new Date().getTime() / 1000);
    var value = {
      ver: 1,
      utc: timestamp,
      region: 'nl'
    };
    categories.forEach(function (category) {
      value[category] = true;
    }, {});
    Cookies.set('cookie-consent', JSON.stringify(value), {
      expires: 365,
      domain: cookieDomain
    });
    onAgree(choices);
  };
  var _onDisagree = function _onDisagree() {
    setDidConsent(STATUS_DECLINED, cookieOptions);
    setAnsweredInCurrentSession(true);
    Cookies.set('cookie-agreed-categories', JSON.stringify([]), {
      expires: 365,
      domain: cookieDomain
    });
    var timestamp = Math.round(new Date().getTime() / 1000);
    var value = {
      ver: 1,
      utc: timestamp,
      region: 'nl'
    };
    Cookies.set('cookie-consent', JSON.stringify(value), {
      expires: 365,
      domain: cookieDomain
    });
    onDisagree();
  };

  // Function for accepting al categories at once.
  var onConsentAll = function onConsentAll() {
    var allCategoriesSelected = categories.reduce(function (prev, category) {
      prev[category] = true;
      return prev;
    }, {});
    _onAgree(allCategoriesSelected);
  };

  // This function is fired when the accept button is pressed.
  // Also has eventual support for a false case.
  var onConsent = function onConsent(value) {
    return function () {
      if (value === true) {
        _onAgree(choicesSelected);
      } else {
        _onDisagree();
      }
    };
  };

  // This function sets the value of the checkmark in the form state.
  var handleChoiceState = function handleChoiceState(event) {
    var _event$target = event.target,
      value = _event$target.value,
      checked = _event$target.checked;
    setChoicesSelected(_objectSpread(_objectSpread({}, choicesSelected), {}, _defineProperty({}, value, checked)));
  };
  var classes = classNames('Cookie', className, {
    'Cookie--prompting': isPrompting,
    'Cookie--loading': isLoading,
    'Cookie--answered': isAnswered,
    // answering refers to the fact that the user has answered in the current session.
    'Cookie--answering': answeredInCurrentSession,
    'Cookie--hidden': isAnswered
  });

  // if it is answered in the current session, we still render the cookie but with the --hidden modifier,
  // allowing consumers to apply an animation if desired. In other words, don't render only if a user has
  // answered in a previous session.
  if (isAnswered && !answeredInCurrentSession) {
    return null;
  }

  // This function renders the different options of checkboxes,
  // allowing us to add more checkboxes eventually.
  var renderChoices = function renderChoices() {
    return cookieLevels.map(function (choice) {
      return /*#__PURE__*/React.createElement("div", {
        className: "Cookie__category col-xs-12 col-lg-6",
        key: choice.value
      }, /*#__PURE__*/React.createElement("div", {
        className: "Checkbox"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        name: "cookie-categories",
        type: "checkbox",
        id: "cookie-category-".concat(choice.value),
        onChange: handleChoiceState,
        label: choice.label,
        value: choice.value,
        checked: choicesSelected[choice.value],
        disabled: choice.disabled
      })), /*#__PURE__*/React.createElement("div", {
        className: "Cookie__category__description"
      }, choice.description));
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: "Cookie__content ".concat(manualChoiceVisible ? 'Cookie__content--full-height' : '')
  }, !manualChoiceVisible ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 Cookie__content__message"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "col-12 Cookie__content__buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "complete-agree",
    className: "Button--cta",
    primary: true,
    onClick: onConsentAll
  }, agreeText), showDisagree && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "Cookie__content__buttons__manual Cookie__content__buttons__manual-disagree ".concat(manualButtonClassname),
    onClick: onConsent(false)
  }, disagreeText), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "Cookie__content__buttons__manual Cookie__content__buttons__manual-agree ".concat(manualButtonClassname),
    onClick: function onClick(e) {
      displayConsentChoices(e);
    }
  }, manualText)))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "Cookie__content__message"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Cookie__checkboxes-container row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, manualHeader), renderChoices())), /*#__PURE__*/React.createElement("div", {
    className: "Cookie__content__buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "Button--cta",
    onClick: onConsent(true)
  }, agreeText))))));
};
export default CookieCompliancePopup;
CookieCompliancePopup.defaultProps = {
  agreeText: 'Accepteren',
  disagreeText: 'Alles weigeren',
  manualText: 'Zelf instellen',
  manualHeader: function manualHeader() {},
  onAgree: function onAgree() {},
  onDisagree: function onDisagree() {},
  showDisagree: false,
  manualButtonClassname: 'icon-after icon-chevron-right icon-variant-2',
  cookieLevels: [{
    value: 'necessary',
    label: 'Benodigd',
    description: '',
    disabled: true
  }, {
    value: 'voorkeuren',
    label: 'Voorkeuren',
    description: '',
    disabled: false
  }, {
    value: 'statistieken',
    label: 'Statistieken',
    description: '',
    disabled: false
  }, {
    value: 'marketing',
    label: 'Marketing',
    description: '',
    disabled: false
  }],
  defaultValues: {
    necessary: true,
    voorkeuren: false,
    statistieken: false,
    marketing: false
  },
  cookieDomain: null,
  cookieOptions: {
    days: 365,
    path: '/'
  }
};
CookieCompliancePopup.propTypes = {
  agreeText: PropTypes.string,
  disagreeText: PropTypes.string,
  manualText: PropTypes.string,
  manualHeader: PropTypes.func,
  manualButtonClassname: PropTypes.string,
  onAgree: PropTypes.func,
  onDisagree: PropTypes.func,
  showDisagree: PropTypes.bool,
  cookieLevels: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    disabled: PropTypes.bool
  })),
  cookieOptions: PropTypes.shape({
    days: PropTypes.number,
    path: PropTypes.string
  }),
  cookieDomain: PropTypes.string,
  defaultValues: PropTypes.shape({
    necessary: PropTypes.bool,
    voorkeuren: PropTypes.bool,
    statistieken: PropTypes.bool,
    marketing: PropTypes.bool
  })
};